import { tickerItems } from '@/mocks/gossipData';

export default function UpdateTicker() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-foreground-100">
      <div className="mx-auto flex items-center gap-4 px-4 md:px-6 py-2">
        <a
          href="#fresh"
          className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-semibold text-background-50 whitespace-nowrap cursor-pointer"
        >
          <span className="pulse-dot inline-block h-1.5 w-1.5 rounded-full bg-accent-300" />
          速递中
        </a>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track items-center gap-10">
            {doubled.map((item, i) => (
              <span
                key={`${item.time}-${i}`}
                className="flex items-center gap-2 text-xs whitespace-nowrap text-foreground-200"
              >
                <span className="text-accent-400">{item.time}</span>
                {item.text}
              </span>
            ))}
          </div>
        </div>
        <div className="hidden md:flex shrink-0 items-center gap-1.5 text-xs text-foreground-400 whitespace-nowrap">
          <i className="ri-time-line" />
          2026-09-05
        </div>
      </div>
    </div>
  );
}